const getAvatar = (color: string) => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Ccircle cx='32' cy='32' r='32' style='fill:%23${color};'/%3E%3C/svg%3E`;
};
export const COLORS = [
  {
    name: "Red",
    value: "#ED1C24",
    selected: false,
    avatar: getAvatar("ED1C24"),
  },
  {
    name: "Dark Red",
    value: "#990000",
    selected: false,
    avatar: getAvatar("990000"),
  },
  {
    name: "Orange",
    value: "#ED5B2C",
    selected: false,
    avatar: getAvatar("ED5B2C"),
  },
  {
    name: "Athletic Gold",
    value: "#EBBA30",
    selected: false,
    avatar: getAvatar("EBBA30"),
  },
  {
    name: "Yellow",
    value: "#FFF200",
    selected: false,
    avatar: getAvatar("990000"),
  },
  {
    name: "Light Green",
    value: "#6DB94A",
    selected: false,
    avatar: getAvatar("6DB94A"),
  },
  {
    name: "Green",
    value: "#00A651",
    selected: false,
    avatar: getAvatar("00A651"),
  },
  {
    name: "Forest Green",
    value: "#055E35",
    selected: false,
    avatar: getAvatar("055E35"),
  },
  {
    name: "Teal",
    value: "#39BCB1",
    selected: false,
    avatar: getAvatar("39BCB1"),
  },
  {
    name: "Athletic Gold 2",
    value: "#EBA006",
    selected: false,
    avatar: getAvatar("EBA006"),
  },
  {
    name: "Light Blue",
    value: "#0885c6",
    selected: false,
    avatar: getAvatar("0885c6"),
  },
  {
    name: "Dark Blue",
    value: "#0D3267",
    selected: false,
    avatar: getAvatar("0D3267"),
  },
  {
    name: "White",
    value: "#FFFFFF",
    selected: false,
    avatar: getAvatar("FFFFFF"),
  },
  {
    name: "Purple",
    value: "#82539B",
    selected: false,
    avatar: getAvatar("82539B"),
  },

  {
    name: "Hot Pink",
    value: "#EC008C",
    selected: false,
    avatar: getAvatar("EC008C"),
  },
  {
    name: "Light Grey",
    value: " #D0DBDA",
    selected: false,
    avatar: getAvatar("D0DBDA"),
  },
  {
    name: "Black",
    value: "#0C0C10",
    selected: false,
    avatar: getAvatar("0C0C10"),
  },
  {
    name: "Brown",
    value: "#945137",
    selected: false,
    avatar: getAvatar("945137"),
  },
  {
    name: "Tan",
    value: "#E2B67B",
    selected: false,
    avatar: getAvatar("E2B67B"),
  },
  {
    name: "Cardinal",
    value: "#C4161C",
    selected: false,
    avatar: getAvatar("C4161C"),
  },
  {
    name: "Vegas Gold",
    value: "#D2AA41",
    selected: false,
    avatar: getAvatar("D2AA41"),
  },
  {
    name: "Royal Blue",
    value: "#006AB6",
    selected: false,
    avatar: getAvatar("006AB6"),
  },
  {
    name: "Light Blue 2",
    value: "#6DCFF6",
    selected: false,
    avatar: getAvatar("6DCFF6"),
  },
];
